<!--/**-->
<!--* 自动生成 vue列表代码【模块名：平台订单数据】-->
<!--* 生成日期：2024/11/21 14:37:32-->
<!--* 生成路径: src/pages/trade/TradeList.vue-->
<!--* 生成人：管理员-->
<!--*/-->
<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <div class='table-search'>
          <el-form :model='searchCondition' inline size='mini' label-width='90px' label-position='right'
                   label-suffix=''>
            <el-form-item label='匹配状态'>
              <el-radio-group v-model="searchCondition.status_match" size="mini">
                <el-radio-button :label="``">全部</el-radio-button>
                <el-radio-button :label="`Y`">已匹配</el-radio-button>
                <el-radio-button :label="`N`">未匹配</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label='归属方式'>
              <el-radio-group v-model="searchCondition.month_type" size="mini">
                <el-radio-button :label="``">全部</el-radio-button>
                <el-radio-button v-for="(mt,mt_key) in MonthTypes" :key="mt_key" :label="mt_key">
                  {{ mt.label }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label='匹配红人'>
              <artist-search :artist-id.sync="searchCondition.artist_id"/>
            </el-form-item>
            <div v-show='showMore' style='display: inline'>
              <el-form-item label='订单 id'>
                <el-input v-model='searchCondition.order_id' placeholder='订单id' clearable></el-input>
              </el-form-item>
              <el-form-item label='商品 id'>
                <el-input v-model='searchCondition.product_id' placeholder='商品id' clearable></el-input>
              </el-form-item>
              <el-form-item label='商品名称'>
                <el-input v-model='searchCondition.product_title' placeholder='商品名称' clearable></el-input>
              </el-form-item>
              <el-form-item label='达人昵称'>
                <el-input v-model='searchCondition.kol_nickname' placeholder='达人昵称' clearable></el-input>
              </el-form-item>
              <el-form-item label='平台ID'>
                <el-input v-model='searchCondition.account_id' placeholder='平台账号ID' clearable></el-input>
              </el-form-item>
              <el-form-item label='店铺id'>
                <el-input v-model='searchCondition.shop_id' placeholder='店铺id' clearable></el-input>
              </el-form-item>
              <el-form-item label='店铺名称'>
                <el-input v-model='searchCondition.shop_name' placeholder='店铺名称' clearable></el-input>
              </el-form-item>
            </div>
            <el-form-item>
              <el-button type='primary' icon='el-icon-search' :disabled='loading' :loading='loading'
                         @click='handleQuery'>搜索
              </el-button>
              <el-button type='text' :icon='!showMore?"el-icon-caret-bottom":"el-icon-caret-top"'
                         @click='showMore=!showMore'>
                {{ !showMore ? '展开' : '隐藏' }}
              </el-button>
            </el-form-item>
            <el-form-item style='float: right'>
              <el-link type='primary' icon='el-icon-link' @click.native.stop='jumpToImport'>前往导入</el-link>
            </el-form-item>
          </el-form>
        </div>

        <!-- 订单导入-基本信息 -->
        <div v-if='info.id' v-loading='infoLoading' class='import-info-card'>
          <div class='import-info-header'>
            <div class='import-info-title'>
              <i class='el-icon-document' />
              <span>订单导入-基本信息</span>
            </div>
            <div class='import-info-actions'>
              <span>导入ID：{{ info.id }}</span>
              <el-link type='primary' icon='el-icon-refresh' :underline='false'
                       @click.native.stop='loadTradeImportInfo'>刷新
              </el-link>
            </div>
          </div>
          <el-descriptions :column='4' border size='small'
                           :label-style='descLabelStyle' :content-style='descContentStyle'>
            <el-descriptions-item label='归属月份'>{{ formatMonth(info.month) }}</el-descriptions-item>
            <el-descriptions-item label='归属平台'>{{ info.platform_name || '--' }}</el-descriptions-item>
            <el-descriptions-item label='归属方式'>
              <span v-if='MonthTypes[info.month_type]'
                    :style='{ color: MonthTypes[info.month_type].color }'>
                {{ MonthTypes[info.month_type].label }}
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label='导入状态'>
              <el-tag :type='stateInfo.type' size='mini' effect='plain'>{{ stateInfo.text }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label='文件名称' :span='2'>
              <el-link v-if='info.file_id' type='primary' :underline='false'
                       @click.native.stop='handleShowExcel'>
                {{ info.file_name || '--' }}
              </el-link>
              <span v-else>{{ info.file_name || '--' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label='导入进度' :span='2'>
              <span class='progress-item'>已导入 <b>{{ $utils.numberFormat(info.row_offset) }}</b> 行</span>
              <el-divider direction='vertical' />
              <span class='progress-item'>表格行 <b>{{ $utils.numberFormat(info.row_count) }}</b> 行</span>
              <el-divider direction='vertical' />
              <span class='progress-item'>已匹配 <b>{{ $utils.numberFormat(info.matched_num) }}</b> 行</span>
            </el-descriptions-item>
            <el-descriptions-item label='导入耗时'>{{ formatDuration(info.used_time) }}</el-descriptions-item>
            <el-descriptions-item label='匹配耗时'>{{ formatDuration(info.matched_time) }}</el-descriptions-item>
            <el-descriptions-item label='导入完成时间'>{{ formatDateTime(info.import_done_at) }}</el-descriptions-item>
            <el-descriptions-item label='匹配完成时间'>{{ formatDateTime(info.matched_done_at) }}</el-descriptions-item>
            <el-descriptions-item label='创建时间'>{{ formatDateTime(info.created_at) }}</el-descriptions-item>
            <el-descriptions-item label='备注' :span='3'>{{ info.remark || '--' }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!--    渲染表格-->
        <div class='default-table'>
          <MlPageTable :all-columns='defaultColumns'
                       :table-name='tableName'
                       :data-list='dataList'
                       :limit.sync='pageData.page_size'
                       :page.sync='pageData.current_page'
                       :total.sync='total'
                       :height='height'
                       highlight-current-row
                       :row-class-name='tableRowClassName'
                       @row-click='rowClickEvent'
                       @getList='getList' border>

            <el-table-column slot="month_type" align='center' width='120' label='归属方式'>
              <template v-slot="{row:{month_type:t}}">
                <span v-if="MonthTypes[t]" :style="{color:MonthTypes[t].color}">{{ MonthTypes[t].label }}</span>
              </template>
            </el-table-column>
          </MlPageTable>
        </div>
      </div>
    </PageHeaderLayout>

    <!-- 导入文件预览 -->
    <el-dialog :visible.sync='fileOpen' fullscreen>
      <div style='padding: 5px'>
        <ExcelPageTable :key='`ExcelPageTable_${fileInfo.id}`' :file-info='fileInfo'
                        ref='refPreviewExcelPageTable' />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MlPageTable from '@/components/common/MlPageTable'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ExportBtn from '@/components/export/ExportBtn'
import {getTradeList,} from '@/api/trade'
import {getTradeImportInfo, optionsTradeImported} from '@/api/trade_import'
import {MonthTypes} from './trade'
import ArtistSearch from '@/components/artist/ArtistSearch.vue'
import ExcelPageTable from '@/pages/trade/import/ExcelPageTable'

export default {
  name: 'TradeList',
  components: {ArtistSearch, ExcelPageTable, ExportBtn, PageHeaderLayout, MlPageTable},
  data() {
    return {
      MonthTypes,
      tableName: 'trade',
      loading: false,
      loadingCommit: false,
      showMore: false,
      dataList: [],
      total: 0,
      height: 800,
      searchCondition: {},
      options: {platform: [], files: [], order_status: []},
      pageData: {current_page: 1, page_size: 20},
      orderBy: {id: 'asc'},
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      defaultColumns: [
        {hide: false, prop: 'id', label: '数据ID', width: 88, sortable: true, fixed: false},
        {hide: true, prop: 'import_id', label: '导入ID', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'month', label: '归属月份', width: 120, sortable: false, fixed: false},
        {
          hide: false,
          prop: 'month_type',
          slot: 'month_type',
          label: '归属方式',
          width: 120,
          sortable: false,
          fixed: false
        },
        {hide: true, prop: 'platform_code', label: '平台代号', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'platform_name', label: '归属平台', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'artist_id', label: '系统红人ID', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'artist_nickname', label: '系统红人昵称', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'order_id', label: '订单 id', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'product_id', label: '商品id', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'product_title', label: '商品名称', width: 220, sortable: false, fixed: false},
        {hide: true, prop: 'order_status', label: '订单状态', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'flow_source', label: '流量来源', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'kol_nickname', label: '达人昵称', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'account_id', label: '平台账号ID', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'amount', label: '成交金额', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'pay_amount', label: '用户实际支付金额', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'sales_amount', label: '有效销售金额', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'settle_amount', label: '结算金额', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'total_ci', label: '总佣金收入', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'eci_kol', label: '预估佣金收入-达人', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'eci_agency', label: '预估佣金收入-机构', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'sci_kol', label: '结算佣金收入-达人', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'sci_agency', label: '结算佣金收入-机构', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'settle_time', label: '订单结算时间', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'ets_fee', label: '预估技术服务费', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'sts_fee', label: '结算技术服务费', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'shop_id', label: '店铺id', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'shop_name', label: '店铺名称', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'eci', label: '预估佣金', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'eer_ci', label: '达人预估奖励佣金收入', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'ier_ci', label: '机构预估奖励佣金收入', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'esr_ci', label: '达人结算奖励佣金收入', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'isr_ci', label: '机构结算奖励佣金收入', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'payment_subsidy', label: '支付补贴', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'platform_subsidy', label: '平台补贴', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'expert_subsidy', label: '达人补贴', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'fare', label: '运费', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'tax', label: '税费', width: 120, sortable: false, fixed: false},
        {hide: true, prop: 'fare_subsidy', label: '运费补贴', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'refund_amount', label: '退款金额', width: 120, sortable: false, fixed: false},
        {hide: false, prop: 'created_at', label: '创建时间', width: 120, sortable: true, fixed: false},
        {hide: false, prop: 'updated_at', label: '修改时间', width: 120, sortable: true, fixed: false}],

      title: '添加/修改-平台订单数据',
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {},
      //是否显示弹出层:导入框
      openImport: false,
      //筛选条件缓存key
      pageSearchKey: 'page_search_key:trade',
      info: {},//导入的基本信息
      infoLoading: false,
      //导入文件预览
      fileOpen: false,
      fileInfo: {id: null, name: null},
      //基本信息描述列表样式
      descLabelStyle: {width: '110px', color: '#606266', background: '#fafafa', fontWeight: 'normal'},
      descContentStyle: {color: '#303133'}
    }
  },
  computed: {
    //导入状态
    stateInfo() {
      const stateMap = {
        0: {text: '待导入', type: 'info'},
        1: {text: '导入中', type: 'warning'},
        2: {text: '导入成功', type: 'success'},
        '-1': {text: '导入失败', type: 'danger'},
        '-2': {text: '已撤回', type: 'info'},
        '-3': {text: '撤回中', type: 'warning'}
      }
      return stateMap[this.info.state] || {text: this.info.state || '--', type: 'info'}
    }
  },
  methods: {
    async loadOptions() {
      // console.time('loadOptions')
      // 加载可选平台，即系统里已录入的平台
      const option1 = await optionsTradeImported()
      // let option2 = await optionsTrade()
      this.options = {...option1, ...{}}
      // console.timeEnd('loadOptions')
    },
    // eslint-disable-next-line no-unused-vars
    rowClickEvent(row, column, event) {
      // this.$notify.info(`数据ID：${row.id}`)
    },
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({row, rowIndex}) {
      return 'default-table-row'
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field]) {
          // console.log(typeof this.searchCondition[field])
          condition[field] = this.searchCondition[field]
        }
      })
      // 分页 +排序
      Object.assign(condition, this.pageData, {orderBy: this.orderBy})

      return condition
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
    },
    async getList() {
      this.dataList = []
      this.loading = true
      const params = this.handleSearchCondition()
      const {list, pages} = await getTradeList(params)
      // this.dataList = [...this.dataList, ...list]
      this.dataList = list
      this.pageData.current_page = pages.current_page || 1
      this.pageData.page_size = pages.page_size || 100
      this.total = pages.total
      this.loading = false
    },

    /** 修改按钮 */
    handleAdd() {
      this.open = true
      this.title = '添加-平台订单数据'

      this.form = {}
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.form = {}
    },
    //导出表格
    jumpToImport() {
      this.$router.push({name: 'trade'})
    },
    // 加载订单导入基本信息（实时进度）
    async loadTradeImportInfo() {
      const importId = Array.isArray(this.searchCondition.import_id)
        ? this.searchCondition.import_id[0]
        : this.searchCondition.import_id
      if (!importId) {
        this.info = {}
        return
      }
      this.infoLoading = true
      try {
        const data = await getTradeImportInfo(importId)
        this.info = (data && data.info) || {}
      } finally {
        this.infoLoading = false
      }
    },
    // 预览导入的原始文件
    handleShowExcel() {
      if (!this.info.file_id) {
        return
      }
      this.fileInfo = {id: this.info.file_id, name: this.info.file_name}
      this.fileOpen = true
      this.$nextTick(() => {
        this.$refs['refPreviewExcelPageTable'].init()
      })
    },
    // 归属月份格式化
    formatMonth(value) {
      return this.formatTime(value, '{y}年{m}月')
    },
    // 日期时间格式化
    formatDateTime(value) {
      return this.formatTime(value, '{y}-{m}-{d} {h}:{i}:{s}')
    },
    formatTime(value, format) {
      if (!value) {
        return '--'
      }
      return this.$utils.parseTime(value, format) || '--'
    },
    // 耗时（毫秒）格式化
    formatDuration(ms) {
      if (!ms || ms < 0) {
        return '--'
      }
      return this.secondsToReadable(ms / 1000)
    },
    // 秒数可读性
    secondsToReadable(seconds) {
      const days = Math.floor(seconds / (3600 * 24))
      const hours = Math.floor((seconds % (3600 * 24)) / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = (seconds % 60).toFixed(2)
      const parts = []
      if (days) parts.push(`${days} 天`)
      if (hours) parts.push(`${hours} 小时`)
      if (minutes) parts.push(`${minutes} 分钟`)
      if (secs || parts.length === 0) parts.push(`${secs} 秒`)
      return parts.join(' ')
    }
  },
  mounted() {
    setTimeout(() => {
      this.loadOptions()
    }, 100)
  },
  created() {
    if (sessionStorage.getItem(this.pageSearchKey)) {
      this.searchCondition = JSON.parse(sessionStorage.getItem(this.pageSearchKey))
    }
    // 携带导入ID进入时（平台数据页「查看详情」），自动按该导入记录筛选订单数据
    const month_type = this.$route.query.month_type
    if (month_type) {
      this.searchCondition.month_type = month_type
    }
    const importId = Array.isArray(this.$route.query.import_id)
        ? this.$route.query.import_id[0]
        : this.$route.query.import_id
    if (importId) {
      this.searchCondition.import_id = [Number(importId)]
    }
    // 存在导入ID（URL 携带或缓存筛选）时，展示订单导入基本信息
    if (Array.isArray(this.searchCondition.import_id) && this.searchCondition.import_id.length > 0) {
      this.loadTradeImportInfo()
    }
    this.handleQuery()
  }
}
</script>

<style scoped>
.import-info-card {
  margin-bottom: 12px;
  padding: 14px 16px 2px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.import-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #ebeef5;
}

.import-info-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.import-info-title i {
  color: #409eff;
  font-size: 16px;
}

.import-info-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 12px;
  color: #909399;
}

.import-info-card .progress-item b {
  color: #303133;
  font-weight: 600;
}
</style>
